import type {AiChatStateContextType} from '@/ai-chat/providers/ai-chat-provider.types';
import {AiAgentMode} from '@/ai-chat/providers/ai-chat-provider.types';
import type {DecisionsAssist, RequestConfig} from '@Components/ai-chat-window/ai-chat-window.types';

/** A super user's decisions switch applies only to agent-mode turns; everyone else sends nothing and gets the environment's setting. */
export const getDecisionsAssistToSend = (state: AiChatStateContextType | undefined, mode: AiAgentMode): DecisionsAssist | null => {
  if (!state?.isSuperUser || mode !== AiAgentMode.AGENT) {
    return null;
  }

  return state.decisionsAssist;
};

export const withDecisionsAssist = (requestConfig: RequestConfig | undefined, decisionsAssist: DecisionsAssist | null): RequestConfig | undefined => {
  if (decisionsAssist === null) {
    return requestConfig;
  }

  return {...requestConfig, preferences: {...requestConfig?.preferences, decisionsAssist}};
};
